import React from 'react';
import { Form, Col } from 'react-bootstrap';
import { FormTextBox } from '../components/FormTextBox';

/**Functional component for tenant information form */
export const TenantForm = (props) => {
    const onChange = (ev, input) => {
        const name = ev.target.name;
        const value = ev.target.value;
        props.setTenant(name, value);
    };
    return <div>
        <h6>Tenant information</h6>
        <Form.Row>
            <FormTextBox formGroupAs={Col} formLabel={"Tenant"} textChanger={onChange}
                name="tenant" readOnly={false} placeholder="Tenant name" value={props.tenantData.tenant || ""} />
            <FormTextBox formGroupAs={Col} formLabel={"Sharepoint url"} textChanger={onChange}
                name="sharepointURL" readOnly={false} placeholder="https://mx3650.sharepoint.com" value={props.tenantData.sharepointURL || ""} />
        </Form.Row>
        <Form.Row>
            <FormTextBox formGroupAs={Col} formLabel={"Client Id"} textChanger={onChange}
                name="clientId" readOnly={false} placeholder="Client ID" value={props.tenantData.clientId || ""} />
            <FormTextBox formGroupAs={Col} formLabel={"Admin User"} textChanger={onChange}
                name="username" readOnly={false} placeholder="Admin User" value={props.tenantData.username || ""} />
        </Form.Row>
    </div>;
};



// WEBPACK FOOTER //
// ./src/components/adminCenter/TenantForm.js